import { render, staticRenderFns } from "./PortalSection.vue?vue&type=template&id=266cb2d4&scoped=true&"
var script = {}
import style0 from "./PortalSection.vue?vue&type=style&index=0&id=266cb2d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "266cb2d4",
  null
  
)

export default component.exports